import RATEHUB_BROKERAGE_IDS from '../definitions/RatehubBrokerageIDs';


export default function isCanwiseProvider(rate) {
    return !!rate
        && (RATEHUB_BROKERAGE_IDS.includes(rate.provider.id) || RATEHUB_BROKERAGE_IDS.includes(rate.provider.brokerage?.id));
}
